import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Spinner,
  Alert,
} from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";

const EditarHistoricoSicom = ({ open, toggle, registro, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [apiResponse, setApiResponse] = useState(null);

  const [form, setForm] = useState(null);

  // 🔄 Cargar registro completo
  useEffect(() => {
    if (registro) {
      setForm(JSON.parse(JSON.stringify(registro))); // copia profunda
    }
  }, [registro]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleCilindroChange = (index, field, value) => {
    const updated = [...form.cilindros];
    updated[index][field] = value;
    setForm({ ...form, cilindros: updated });
  };

  const handleReguladorChange = (index, field, value) => {
    const updated = [...form.reguladores];
    updated[index][field] = value;
    setForm({ ...form, reguladores: updated });
  };
  const actualizar = async () => {
    // 🔴 Validación básica
    if (!form?.placa && !form?.vin) {
      Swal.fire({
        icon: "warning",
        title: "Datos incompletos",
        text: "Debe existir placa o VIN para actualizar el registro",
        confirmButtonText: "Entendido",
      });
      return;
    }

    setLoading(true);

    // 🔄 Loading SweetAlert
    Swal.fire({
      title: "Actualizando información",
      text: "Por favor espere...",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      // 🔧 Construcción de parámetros
      const params = new URLSearchParams();
      if (form.placa) params.append("placa", form.placa);
      if (form.vin) params.append("vin", form.vin);

      const url = `https://inspecciongnvback-dev.azurewebsites.net/api/v1/ActualizarHistoricoSicom?${params.toString()}`;

      // 🔴 Backend espera ARRAY
      const payload = [form];

      await axios.put(url, payload, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      // ✅ Éxito
      Swal.fire({
        icon: "success",
        title: "Actualización exitosa",
        text: "El histórico SICOM fue actualizado correctamente",
        timer: 2000,
        showConfirmButton: false,
      });

      onSuccess(); // 🔄 recarga tabla
      toggle(); // ❌ cierra modal
    } catch (error) {
      console.error(error);

      // ❌ Error
      Swal.fire({
        icon: "error",
        title: "Error al actualizar",
        text:
          error?.response?.data?.message ||
          "Ocurrió un error inesperado al actualizar el registro",
        confirmButtonText: "Cerrar",
      });
    } finally {
      setLoading(false);
    }
  };

  if (!form) return null;

  return (
    <Modal isOpen={open} toggle={toggle} size="lg" centered>
      <ModalHeader toggle={toggle}>Editar Histórico SICOM</ModalHeader>

      <ModalBody>
        {apiResponse && (
          <Alert color="info">
            <strong>Respuesta API:</strong>
            <pre style={{ whiteSpace: "pre-wrap" }}>
              {JSON.stringify(apiResponse, null, 2)}
            </pre>
          </Alert>
        )}

        <Form>
          {/* ID BLOQUEADO */}
          <FormGroup>
            <Label>ID</Label>
            <Input value={form.id} disabled />
          </FormGroup>

          <FormGroup>
            <Label>Placa</Label>
            <Input name="placa" value={form.placa || ""} disabled />
          </FormGroup>

          <FormGroup>
            <Label>VIN</Label>
            <Input name="vin" value={form.vin || ""} disabled />
          </FormGroup>

          <FormGroup>
            <Label>Chip ROM</Label>
            <Input
              name="chipIdRom"
              value={form.chipIdRom || ""}
              onChange={handleChange}
            />
          </FormGroup>

          <FormGroup>
            <Label>Ciudad</Label>
            <Input
              name="ciudad"
              value={form.ciudad || ""}
              onChange={handleChange}
            />
          </FormGroup>

          <FormGroup>
            <Label>Certificador</Label>
            <Input
              name="certificador"
              value={form.certificador || ""}
              onChange={handleChange}
            />
          </FormGroup>

          <FormGroup>
            <Label>NIT Certificador</Label>
            <Input
              name="nitCertificador"
              value={form.nitCertificador || ""}
              onChange={handleChange}
            />
          </FormGroup>

          <hr />
          {/* CILINDROS */}
          <h5>Cilindros</h5>
          {form.cilindros?.map((c, i) => (
            <div
              key={i}
              style={{
                border: "1px solid #ddd",
                padding: 10,
                marginBottom: 10,
              }}
            >
              <FormGroup>
                <Label>Marca Cilindro</Label>
                <Input
                  value={c.marcaCilindro || ""}
                  onChange={(e) =>
                    handleCilindroChange(i, "marcaCilindro", e.target.value)
                  }
                />
              </FormGroup>

              <FormGroup>
                <Label>Serial Cilindro</Label>
                <Input
                  value={c.serialCilindro || ""}
                  onChange={(e) =>
                    handleCilindroChange(i, "serialCilindro", e.target.value)
                  }
                />
              </FormGroup>

              <FormGroup>
                <Label>Capacidad</Label>
                <Input
                  type="number"
                  value={c.capacidad || ""}
                  onChange={(e) =>
                    handleCilindroChange(i, "capacidad", e.target.value)
                  }
                />
              </FormGroup>
            </div>
          ))}

          <hr />

          {/* REGULADORES */}
          <h5>Reguladores</h5>
          {form.reguladores?.map((r, i) => (
            <div key={i} style={{ border: "1px solid #ddd", padding: 10 }}>
              <FormGroup>
                <Label>Marca Regulador</Label>
                <Input
                  value={r.marcaRegulador || ""}
                  onChange={(e) =>
                    handleReguladorChange(i, "marcaRegulador", e.target.value)
                  }
                />
              </FormGroup>

              <FormGroup>
                <Label>Serial Regulador</Label>
                <Input
                  value={r.serialRegulador || ""}
                  onChange={(e) =>
                    handleReguladorChange(i, "serialRegulador", e.target.value)
                  }
                />
              </FormGroup>
            </div>
          ))}
        </Form>
      </ModalBody>

      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Cancelar
        </Button>
        <Button color="primary" onClick={actualizar} disabled={loading}>
          {loading ? <Spinner size="sm" /> : "Guardar cambios"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default EditarHistoricoSicom;
